import React, { Dispatch, FC, SetStateAction } from "react";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { WidgetListTheme } from "@xapp/intelligent-search-widget";
import { SearchWidgetCardThemeBuilder } from "./SearchWidgetCardThemeBuilder";

export interface SearchWidgetListThemeBuilderProps {
    readonly theme: WidgetListTheme | undefined;
    readonly defaultTheme: WidgetListTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<WidgetListTheme>>;
}

const EMPTY_THEME: WidgetListTheme = {};

const SearchWidgetListThemeBuilderInner: FC<SearchWidgetListThemeBuilderProps> = props => {
    const theme: WidgetListTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: WidgetListTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const handleCardChange = useOnChangeChildDispatch("card", onChange);

    return (
        <SearchWidgetCardThemeBuilder label="List" theme={theme.card} defaultTheme={defaultTheme.card} onChange={handleCardChange} />
    );
};

export const SearchWidgetListThemeBuilder = React.memo(SearchWidgetListThemeBuilderInner);
